import { render, staticRenderFns } from "./CalendarEdit.vue?vue&type=template&id=840791be&scoped=true&"
import script from "./CalendarEdit.vue?vue&type=script&lang=js&"
export * from "./CalendarEdit.vue?vue&type=script&lang=js&"
import style0 from "./CalendarEdit.vue?vue&type=style&index=0&id=840791be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840791be",
  null
  
)

export default component.exports